import { createActionsHook } from 'src/lib/sweetState';

import Store from './Store';

export const useUserActions = createActionsHook(Store);
